var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTabSegmentation = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 22,
  height: 22,
  viewBox: "0 0 22 22",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  stroke: "currentColor",
  cx: 11.037,
  cy: 10.912,
  r: 8
}), /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  d: "m11.354 3.575-7.779 7.779m13.789-4.597L6.757 17.364"
}), /*#__PURE__*/React.createElement("path", {
  d: "m18.955 9.763-9.192 9.192"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  d: "M15.066 4.46 4.459 15.065"
})), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h22v22H0z"
}))));
export { SvgTabSegmentation as ReactComponent };
export default __webpack_public_path__ + "assets/images/tab-segmentation.svg";